import geosIco from "./geosIco.svg";
import bikLogo from "./bikLogo.svg";
import Checkmark from "./Checkmark.svg";
import geosBik from "./geosBik.svg";
import HelpCircle from "./helpCircle.svg";
import AlertCircle from "./AlertCircle.svg";
import Smileys from "./Smileys.svg";
import fileCopy from "./document-file-copy.svg";
import chevronDown from "./chevronDown.svg";
import check from "./check.svg";
import floppyCheckmark from "./floppyCheckmark.svg";
import Pencil from "./Pencil.svg";
import Close from "./Close.svg";
import file from "./file.svg";
import TrashOne from "./TrashOne.svg";
import Arrow from "./Arrow.svg";
import CheckCircle from "./CheckCircle.svg";
import fileDownload from "./fileDownload.svg";
import markerPin from "./markerPin.svg";
import map from "./map.svg";
import map1 from "./map1.svg";
import xClose from "./xClose.svg";
import lock from "./lock.svg";
import ArrowBackCol from "./ArrowBackCol.svg";
import alertCircle from "./alert-circle.svg";
import Filter from "./Filter.svg";
import refreshRotate from "./refreshRotate.svg";
import xClosed from "./xClosed.svg";
import Logo from "./Logo.svg";
import Mark from "./Mark.svg";
import logOut from "./logOut.svg";
import plusCircle from "./plus-circle.svg";
import linkExt from "./linkExt.svg";
import checkBlack from "./checkBlack.svg";
import edit from "./edit.svg";
import LogoSvoi from "./LogoSvoi.jpg";
import Vkontakte from "./Vkontakte.svg";
import bg from "./bg.svg";
import portrait from "./portrait.png";
import User from "./User.png";
import User1 from "./User-1.png";
import User2 from "./User-2.png";
import User3 from "./User-3.png";
import User4 from "./User-4.png";
import User5 from "./User-5.png";
import User6 from "./User-6.png";
import User7 from "./User-7.png";
import Footerbg from "./footerbg.svg";
import arrowLeft from "./arrow-left.svg";
import Indicator from "./Indicator.svg";
import arrowRightOrange from "./arrowRightOrange.svg";
import userCheck from "./userCheck.svg";
import LogoWhite from "./LogoWhite.svg";
import checkVerified from "./checkVerified.svg";
import lightning from "./lightning.svg";
import Clock from "./Clock.svg";
export default {
  geosIco,
  bikLogo,
  Checkmark,
  geosBik,
  AlertCircle,
  HelpCircle,
  Smileys,
  fileCopy,
  chevronDown,
  check,
  floppyCheckmark,
  Pencil,
  Close,
  file,
  TrashOne,
  Arrow,
  CheckCircle,
  fileDownload,
  markerPin,
  map,
  map1,
  xClose,
  lock,
  ArrowBackCol,
  alertCircle,
  Filter,
  refreshRotate,
  xClosed,
  Logo,
  Mark,
  logOut,
  plusCircle,
  linkExt,
  checkBlack,
  edit,
  LogoSvoi,
  Vkontakte,
  bg,
  portrait,
  User,
  User1,
  User2,
  User3,
  User4,
  User5,
  User6,
  User7,
  Footerbg,
  arrowLeft,
  Indicator,
  arrowRightOrange,
  userCheck,
  LogoWhite,
  checkVerified,
  lightning,
  Clock,
};
